import * as tslib_1 from "tslib";
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { QueueItemService, } from '@services';
var TransactionAttemptSource = /** @class */ (function () {
    function TransactionAttemptSource(_queueItems) {
        this._queueItems = _queueItems;
    }
    Object.defineProperty(TransactionAttemptSource.prototype, "mapper", {
        get: function () {
            return this._queueItems.mapper;
        },
        enumerable: true,
        configurable: true
    });
    TransactionAttemptSource.prototype.get = function (qo) {
        return this._queueItems.getQueueItemHistory(this.queueItemId, qo);
    };
    return TransactionAttemptSource;
}());
export { TransactionAttemptSource };
var TransactionAttemptsGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionAttemptsGridComponent, _super);
    function TransactionAttemptsGridComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TransactionAttemptsGridComponent.prototype, "queueItem", {
        set: function (value) {
            var svc = this._service;
            if (!svc ||
                !value ||
                svc.queueItemId === value.id) {
                return;
            }
            svc.queueItemId = value.id;
            this._refresh$.next();
        },
        enumerable: true,
        configurable: true
    });
    return TransactionAttemptsGridComponent;
}(ODataGridComponent));
export { TransactionAttemptsGridComponent };
